export let routes = [
    {
      path: '/x3-side-goods',
      name: 'x3-side-goods',
      component: () => import('@x3/js/side/goods/goods.vue'),
      meta: {
        vx_animate: 'none',
      },
    },
  ];
  
  export let api = {
    xsGoods(options) {
      return new Promise((resolve, reject) => {
        app.router.push(
          '/x3-side-goods',
          route => {
            route.meta._resolve = resolve;
            route.meta._reject = reject;
            route.meta.options = options;
          },
          err => {
            console.log(err);
          }
        );
      });
    },
  };
  